<div class="flex h-screen flex-col">
  <pl-topbar class="pl-2 pr-4">
    <button
      pl-topbar-start
      class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full hover:bg-[var(--mat-sys-on-surface)]/10"
      [plNavigationTrigger]="nav"
      [attr.aria-label]="'topbar.toggleNavigation' | transloco"
    >
      <mat-icon class="material-symbols-outlined">menu</mat-icon>
    </button>
    <app-logo pl-topbar-start class="h-6 w-auto" />
    <button
      pl-topbar-end
      class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full hover:bg-[var(--mat-sys-on-surface)]/10"
      (click)="openSearch()"
      [attr.aria-label]="'topbar.search' | transloco"
    >
      <mat-icon class="material-symbols-outlined">search</mat-icon>
    </button>
    <button
      pl-topbar-end
      class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full hover:bg-[var(--mat-sys-on-surface)]/10"
      (click)="openAiChat()"
      [attr.aria-label]="'topbar.openAiChat' | transloco"
    >
      <mat-icon class="material-symbols-outlined">chat</mat-icon>
    </button>
    <button
      pl-topbar-end
      class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-sm font-semibold uppercase hover:bg-[var(--mat-sys-on-surface)]/10"
      (click)="toggleLanguage()"
      [attr.aria-label]="
        (nextLang() === 'es' ? 'topbar.switchToSpanish' : 'topbar.switchToEnglish') | transloco
      "
    >
      {{ nextLang() }}
    </button>
    <pl-theme-toggle pl-topbar-end />
  </pl-topbar>

  <div class="flex flex-1 overflow-hidden">
    <pl-navigation #nav class="shrink-0" [pages]="navLinks()" />
    <pl-drawer
      class="min-w-0 flex-1 overflow-auto"
      [ariaLabel]="'aiChat.label' | transloco"
      mode="docked"
      [open]="drawerOpen()"
      (openedChange)="drawerOpen.set($event)"
    >
      <main class="h-full overflow-auto p-6">
        <div class="mx-auto max-w-2xl">
          <router-outlet />
        </div>
      </main>
      <div
        pl-drawer-panel
        class="flex h-full flex-col items-center justify-center gap-3 p-6 text-center"
      >
        <mat-icon class="material-symbols-outlined text-4xl opacity-40">chat</mat-icon>
        <p class="text-sm text-[var(--mat-sys-on-surface-variant)]">
          {{ 'aiChat.comingSoon' | transloco }}
        </p>
      </div>
    </pl-drawer>
  </div>
</div>

<pl-command-palette />
